// Vendor
import {compose, createStore, Store} from 'redux';
import persistState, {mergePersistedState} from 'redux-localstorage';
import filter from 'redux-localstorage-filter';
import * as adapter from 'redux-localstorage/lib/adapters/localStorage';

// Reducers & State
import {rootReducer, RootState} from 'isee/redux';

export type ISeeStore = Store<RootState>;

const composeEnhancers =
  (process.env.NODE_ENV === 'development' &&
    window &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

function configureStore(initialState?: RootState) {
  const reducer = compose(mergePersistedState())(rootReducer);
  const storage = compose(filter('session'))(adapter(window.localStorage));

  const enhancer = composeEnhancers(
    persistState(storage, 'isee-persisted-state')
  );

  return createStore<RootState>(reducer, initialState!, enhancer);
}

export class ReduxService {
  private _store: ISeeStore;
  public get store(): ISeeStore {
    return this._store;
  }

  constructor() {
    this._store = configureStore();
  }
}

export default new ReduxService();



// WEBPACK FOOTER //
// ./src/services/redux/redux.ts